<section class="content-section fp-page">

  <!-- ── En-tête ─────────────────────────────────────────────────── -->
  <div class="section-header no-print" style="margin-bottom: 24px;">
    <div>
      <h3 style="margin: 0 0 6px 0;">Mes Fiches de Paie</h3>
      <span class="text-secondary">Gains, primes et progression — {{ nomLivreur }}</span>
    </div>
    <button class="btn btn-outline" (click)="imprimer()">
      <i class="fal fa-print"></i> Imprimer
    </button>
  </div>

  <!-- ── Chargement ──────────────────────────────────────────────── -->
  <div *ngIf="chargement" style="text-align:center; padding: 4rem;">
    <div class="spinner"></div>
  </div>

  <div *ngIf="!chargement && erreur" style="color: var(--danger-color); text-align: center; padding: 2rem;">
    {{ erreur }}
  </div>

  <ng-container *ngIf="!chargement && !erreur">

    <!-- ── Résumé cumul ─────────────────────────────────────────── -->
    <div class="kpi-row no-print">
      <div class="kpi-card">
        <span class="kpi-icon"><i class="fal fa-box-check"></i></span>
        <div>
          <div class="kpi-val">{{ coursesTotal }}</div>
          <div class="kpi-label">Livraisons totales</div>
        </div>
      </div>
      <div class="kpi-card" *ngIf="stats">
        <span class="kpi-icon kpi-icon--green"><i class="fal fa-coins"></i></span>
        <div>
          <div class="kpi-val">{{ formaterMontant(stats.gainsTotaux) }}</div>
          <div class="kpi-label">Gains cumulés (all-time)</div>
        </div>
      </div>
      <div class="kpi-card">
        <span class="kpi-icon kpi-icon--purple"><i class="fal fa-badge-check"></i></span>
        <div>
          <div class="kpi-val">{{ formaterMontant(totalPayeNet) }}</div>
          <div class="kpi-label">Total perçu (primes payées)</div>
        </div>
      </div>
      <div class="kpi-card" *ngIf="stats">
        <span class="kpi-icon kpi-icon--amber"><i class="fal fa-star"></i></span>
        <div>
          <div class="kpi-val">{{ stats.noteMoyenne != null ? (stats.noteMoyenne | number:'1.1-1') : '—' }} / 5</div>
          <div class="kpi-label">Note clients ({{ stats.nbAvis }} avis)</div>
        </div>
      </div>
    </div>

    <!-- ── Parcours des niveaux ────────────────────────────────── -->
    <div class="card-section" *ngIf="niveaux.length">
      <h4 class="card-section-title">
        <i class="fal fa-medal"></i> Parcours des niveaux
      </h4>
      <div class="niveaux-track">
        <div *ngFor="let n of niveaux" class="niveau-step"
             [class.niveau-step--atteint]="niveauAtteint(n)"
             [class.niveau-step--actuel]="niveauActuel?.id === n.id"
             [style.--nc]="n.couleur || '#888'">
          <div class="niveau-badge">
            <span class="niveau-emoji">{{ n.emoji || '🏅' }}</span>
          </div>
          <div class="niveau-info">
            <span class="niveau-nom">{{ n.nom }}</span>
            <span class="niveau-seuil">{{ n.seuilMinCourses }}+ livraisons</span>
            <span class="niveau-prime" *ngIf="n.primeFixeMensuelle > 0 || n.primePourcentageCa > 0">
              {{ n.primeFixeMensuelle > 0 ? formaterMontant(n.primeFixeMensuelle) : '' }}
              {{ n.primeFixeMensuelle > 0 && n.primePourcentageCa > 0 ? ' + ' : '' }}
              {{ n.primePourcentageCa > 0 ? n.primePourcentageCa + '% CA' : '' }}
            </span>
          </div>
          <div class="niveau-check" *ngIf="niveauAtteint(n)">
            <i class="fal fa-check-circle"></i>
          </div>
          <div class="niveau-lock" *ngIf="!niveauAtteint(n)">
            <i class="fal fa-lock"></i>
          </div>
        </div>
      </div>

      <!-- Barre de progression vers niveau suivant -->
      <div class="progress-section" *ngIf="niveauSuivant">
        <div class="progress-label">
          <span>Progression vers <strong>{{ niveauSuivant.nom }}</strong></span>
          <span>{{ coursesTotal }} / {{ niveauSuivant.seuilMinCourses }} livraisons</span>
        </div>
        <div class="progress-bar-bg">
          <div class="progress-bar-fill" [style.width.%]="progressionVersNiveauSuivant()"
               [style.background]="niveauSuivant.couleur || 'var(--primary-color)'"></div>
        </div>
        <p style="font-size: 12px; color: var(--text-secondary); margin-top: 6px;">
          Encore <strong>{{ niveauSuivant.seuilMinCourses - coursesTotal }}</strong> livraisons avant d'atteindre le niveau {{ niveauSuivant.nom }}
        </p>
      </div>
      <div class="progress-section" *ngIf="!niveauSuivant && niveauActuel">
        <p style="font-size: 13px; color: #059669; font-weight: 600; margin: 0;">
          {{ niveauActuel.emoji }} Félicitations ! Vous avez atteint le niveau maximum.
        </p>
      </div>
    </div>

    <!-- ── Historique des fiches de paie ──────────────────────── -->
    <div class="card-section">
      <h4 class="card-section-title">
        <i class="fal fa-file-invoice"></i> Historique des gains par mois
      </h4>

      <div *ngIf="!primes.length" class="empty-state">
        <i class="fal fa-inbox" style="font-size: 2rem; opacity: .4;"></i>
        <p>Aucune fiche de paie disponible pour le moment.</p>
        <small>Les fiches sont générées par la comptabilité en fin de mois.</small>
      </div>

      <div *ngIf="primes.length" class="fiches-list">
        <div *ngFor="let p of primes" class="fiche-row"
             [class.fiche-row--selected]="primeSelectionnee?.id === p.id"
             (click)="ouvrirReleve(p)">
          <div class="fiche-mois">
            <i class="fal fa-calendar-alt"></i>
            <strong>{{ formaterMois(p.moisAnnee) }}</strong>
          </div>
          <div class="fiche-kpis">
            <div class="fiche-kpi">
              <span class="fiche-kpi-label">Livraisons</span>
              <span class="fiche-kpi-val">{{ p.nbLivraisons }}</span>
            </div>
            <div class="fiche-kpi">
              <span class="fiche-kpi-label">Points</span>
              <span class="fiche-kpi-val">{{ p.totalPoints }}</span>
            </div>
            <div class="fiche-kpi">
              <span class="fiche-kpi-label">Base</span>
              <span class="fiche-kpi-val">{{ formaterMontant(p.montantBase || 0) }}</span>
            </div>
            <div class="fiche-kpi">
              <span class="fiche-kpi-label">Prime</span>
              <span class="fiche-kpi-val fiche-kpi-val--prime">{{ formaterMontant(p.montantPrime || 0) }}</span>
            </div>
            <div class="fiche-kpi fiche-kpi--total">
              <span class="fiche-kpi-label">Total</span>
              <span class="fiche-kpi-val fiche-kpi-val--total">{{ formaterMontant(totalMois(p)) }}</span>
            </div>
          </div>
          <div class="fiche-statut">
            <span class="fp-badge" [ngClass]="statutClass(p.statut)">{{ statutLabel(p.statut) }}</span>
            <span *ngIf="p.datePayement" class="fiche-date-paie">payée le {{ p.datePayement | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="fiche-chevron">
            <i class="fal" [class.fa-chevron-down]="primeSelectionnee?.id !== p.id"
               [class.fa-chevron-up]="primeSelectionnee?.id === p.id"></i>
          </div>
        </div>

        <!-- ── Détail relevé mensuel ─────────────────────────── -->
        <ng-container *ngIf="primeSelectionnee">
          <div class="releve-panel" *ngIf="chargementReleve" style="padding: 2rem; text-align:center;">
            <div class="spinner spinner--sm"></div>
          </div>

          <div class="releve-panel" *ngIf="!chargementReleve && releveSelectionne">

            <!-- En-tête imprimable fiche de paie -->
            <div class="releve-header print-only">
              <div>
                <h2 style="margin: 0;">FICHE DE PAIE</h2>
                <p style="margin: 4px 0 0;">{{ formaterMois(releveSelectionne.moisAnnee) }}</p>
              </div>
              <div style="text-align: right;">
                <strong>Dematral Express</strong><br>
                <small>Kan konpal Livreur</small>
              </div>
            </div>

            <div class="releve-infos">
              <div class="releve-info-block">
                <span class="releve-info-label">Employé</span>
                <span class="releve-info-val">{{ releveSelectionne.personnelPrenom }} {{ releveSelectionne.personnelNom }}</span>
              </div>
              <div class="releve-info-block" *ngIf="personnel?.numeroMatricule">
                <span class="releve-info-label">Matricule</span>
                <span class="releve-info-val">{{ personnel?.numeroMatricule }}</span>
              </div>
              <div class="releve-info-block" *ngIf="personnel?.poste">
                <span class="releve-info-label">Poste</span>
                <span class="releve-info-val">{{ personnel?.poste }}</span>
              </div>
              <div class="releve-info-block" *ngIf="niveauActuel">
                <span class="releve-info-label">Niveau</span>
                <span class="releve-info-val">{{ niveauActuel.emoji }} {{ niveauActuel.nom }}</span>
              </div>
            </div>

            <div class="releve-synthese">
              <div class="releve-ligne">
                <span>Nombre de livraisons</span>
                <strong>{{ releveSelectionne.nbLivraisons }}</strong>
              </div>
              <div class="releve-ligne">
                <span>Points accumulés</span>
                <strong>{{ releveSelectionne.totalPoints }} pts</strong>
              </div>
              <div class="releve-ligne" *ngIf="releveSelectionne.montantBase">
                <span>Montant de base</span>
                <strong>{{ formaterMontant(releveSelectionne.montantBase) }}</strong>
              </div>
              <div class="releve-ligne releve-ligne--prime" *ngIf="releveSelectionne.montantPrime">
                <span>Prime de performance</span>
                <strong>+ {{ formaterMontant(releveSelectionne.montantPrime) }}</strong>
              </div>
              <div class="releve-ligne releve-ligne--total">
                <span>TOTAL NET</span>
                <strong>{{ formaterMontant((releveSelectionne.montantBase || 0) + (releveSelectionne.montantPrime || 0)) }}</strong>
              </div>
            </div>

            <!-- Détail des livraisons -->
            <div *ngIf="releveSelectionne.details?.length" class="releve-details">
              <h5 style="margin: 0 0 10px; font-size: 13px; color: var(--text-secondary);">
                Détail des livraisons ({{ releveSelectionne.details.length }})
              </h5>
              <table class="detail-table">
                <thead>
                  <tr>
                    <th>Commande</th>
                    <th>Date</th>
                    <th>Points</th>
                    <th>Montant</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let d of releveSelectionne.details">
                    <td>{{ d.commandeNumero || d.commandeId || '—' }}</td>
                    <td>{{ d.date ? (d.date | date:'dd/MM/yyyy') : '—' }}</td>
                    <td>{{ d.points ?? d.nbPoints ?? '—' }}</td>
                    <td>{{ d.montant != null ? formaterMontant(d.montant) : '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="releve-actions no-print">
              <button class="btn btn-primary" (click)="imprimer()">
                <i class="fal fa-print"></i> Imprimer cette fiche
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Totaux bas de page -->
      <div class="fiches-totaux" *ngIf="primes.length">
        <div class="total-row">
          <span>Total perçu (primes payées)</span>
          <strong>{{ formaterMontant(totalPayeBase) }} base + {{ formaterMontant(totalPayePrime) }} primes = {{ formaterMontant(totalPayeNet) }}</strong>
        </div>
      </div>
    </div>

  </ng-container>
</section>
